/** biome-ignore-all lint/correctness/noUnusedImports: reason */

import { isBefore, subMonths } from "date-fns";

import isThisMonth from "date-fns/is_this_month";
import isThisWeek from "date-fns/is_this_week";
import isThisYear from "date-fns/is_this_year";

import React, { createContext, useContext, useEffect, useState } from "react";

import {
  clientHelper,
  TotalKegsHelper,
  totalVolumeHelper,
} from "../../../app/helpers/volumeHelpers";

import { useAuth } from "../auth";
import { useReports } from "../reports";

const VolumeContext = createContext(null);
const now = new Date();
const sixMonthsAgo = subMonths(now, 6);
const threeMonthsAgo = subMonths(now, 3);

const VolumeProvider = ({ children }) => {
  const { reports_kegs_dispatched, getReport } = useReports();
  const { claims } = useAuth();

  const [pdfData, setPdfData] = useState(null);
  const [client, setClient] = useState();
  const [filteredKegs, setFilteredKegs] = useState([]);
  const [brand, setBrand] = useState();
  const [totalVolume, setTotalVolume] = useState(0);
  const [totalKegs, setTotalKegs] = useState(0);
  const [date, setDate] = useState();

  useEffect(() => {
    if (!claims?.companyLink) return () => {};
    return getReport("reports_kegs_dispatched", "companyLink");
  }, [
    claims?.companyLink,
    getReport,
  ]);

  useEffect(() => {
    if (reports_kegs_dispatched) {
      const clientKegs = reports_kegs_dispatched.filter(keg => keg.clientLink);

      if (date) {
        if (date === "weekly") {
          const updatedKegs = clientKegs.filter(keg =>
            isThisWeek(keg.dateDispatched?.toDate())
          );

          if (client) {
            clientHelper(
              client,
              brand,
              updatedKegs,
              setFilteredKegs,
              setTotalVolume,
              setTotalKegs
            );
          } else {
            const filteredTotalVolume = totalVolumeHelper(updatedKegs);
            const filteredTotalKegs = TotalKegsHelper(updatedKegs);

            setTotalVolume(filteredTotalVolume);
            setTotalKegs(filteredTotalKegs);
            setClient(undefined);
            setFilteredKegs(updatedKegs);
          }
        }

        if (date === "monthly") {
          const updatedKegs = clientKegs.filter(keg =>
            isThisMonth(keg.dateDispatched?.toDate())
          );

          if (client) {
            clientHelper(
              client,
              brand,
              updatedKegs,
              setFilteredKegs,
              setTotalVolume,
              setTotalKegs
            );
          } else {
            const filteredTotalVolume = totalVolumeHelper(updatedKegs);
            const filteredTotalKegs = TotalKegsHelper(updatedKegs);

            setTotalVolume(filteredTotalVolume);
            setTotalKegs(filteredTotalKegs);
            setClient(undefined);
            setFilteredKegs(updatedKegs);
          }
        }

        if (date === "quartely") {
          const updatedKegs = clientKegs.filter(keg =>
            isBefore(keg.dateDispatched?.toDate(), threeMonthsAgo)
          );

          if (client) {
            clientHelper(
              client,
              brand,
              updatedKegs,
              setFilteredKegs,
              setTotalVolume,
              setTotalKegs
            );
          } else {
            const filteredTotalVolume = totalVolumeHelper(updatedKegs);
            const filteredTotalKegs = TotalKegsHelper(updatedKegs);

            setTotalVolume(filteredTotalVolume);
            setTotalKegs(filteredTotalKegs);
            setClient(undefined);
            setFilteredKegs(updatedKegs);
          }
        }
        if (date === "second") {
          const updatedKegs = clientKegs.filter(keg =>
            isBefore(keg.dateDispatched?.toDate(), sixMonthsAgo)
          );

          if (client) {
            clientHelper(
              client,
              brand,
              updatedKegs,
              setFilteredKegs,
              setTotalVolume,
              setTotalKegs
            );
          } else {
            const filteredTotalVolume = totalVolumeHelper(updatedKegs);
            const filteredTotalKegs = TotalKegsHelper(updatedKegs);

            setTotalVolume(filteredTotalVolume);
            setTotalKegs(filteredTotalKegs);
            setClient(undefined);
            setFilteredKegs(updatedKegs);
          }
        }

        if (date === "year") {
          const updatedKegs = clientKegs.filter(keg =>
            isThisYear(keg?.dateDispatched?.toDate())
          );

          if (client) {
            clientHelper(
              client,
              brand,
              updatedKegs,
              setFilteredKegs,
              setTotalVolume,
              setTotalKegs
            );
          } else {
            const filteredTotalVolume = totalVolumeHelper(updatedKegs);
            const filteredTotalKegs = TotalKegsHelper(updatedKegs);

            setTotalVolume(filteredTotalVolume);
            setTotalKegs(filteredTotalKegs);
            setClient(undefined);
            setFilteredKegs(updatedKegs);
          }
        }
      } else {
        if (client) {
          clientHelper(
            client,
            brand,
            clientKegs,
            setFilteredKegs,
            setTotalVolume,
            setTotalKegs
          );
        } else {
          setFilteredKegs(clientKegs);

          const filteredTotalVolume = totalVolumeHelper(clientKegs);
          const filteredTotalKegs = TotalKegsHelper(clientKegs);

          setClient(undefined);
          setTotalVolume(filteredTotalVolume);
          setTotalKegs(filteredTotalKegs);
        }
      }
    }
  }, [
    reports_kegs_dispatched,
    date,
    client,
    brand,
  ]);

  useEffect(() => {
    if (!client) setBrand(undefined);
  }, [
    client,
  ]);

  return (
    <VolumeContext.Provider
      value={{
        brand,
        client,
        dispatchedVolume: filteredKegs,
        pdfData,
        setBrand,
        setClient,
        setDate,
        setPdfData,
        totalKegs,
        totalVolume,
      }}
    >
      {children}
    </VolumeContext.Provider>
  );
};

export default VolumeProvider;

export const useVolume = () => useContext(VolumeContext);
